import {FormGroup} from '@angular/forms';
import {Operation} from './Operation';
import { TerminalDeliveryModel } from '../interface/terminal-delivery-model';

export class ShoppingCart {
    private operation = new Operation();
    private address = '';
    private provincia = '';
    private items = [];
    private total = 0;
    private pdv;
    private terminalDelivery: TerminalDeliveryModel;

    constructor() {
    }

    update(data: FormGroup) {
        if (data !== null && data.controls !== undefined) {
            if (data.value.hasOwnProperty('resultadoConsultaCobertura')) {
                this.operation.setFormularioResultadoCobertura(data);
                this.updateAddress(data);
            }
            if (data.value.hasOwnProperty('provinciaNormaliza')) {
                this.operation.setFormularioNormalizacion(data);
                this.provincia = this.parseText(data.get('provinciaNormaliza').value);
            }
            if (data.contains('rate')) {
                this.addItem(data);
            }
            if (data.getRawValue().doctype) { //  data.contains('doctype')
                this.operation.setUserData(data);
            }
            if (data.contains('account_doctype')) {
                this.operation.setBankData(data);
            }
            if (data.contains('commercial_communications')) {
                this.operation.setPreActivationData(data);
            }
            // Parche para obtener el numero del fijo a portar
            if (data.value.hasOwnProperty('resultadoConsultaCobertura')) {
                if (this.items && this.items.length && this.items[0]['type_operation'] !== 'registration') {
                    this.items[0]['portability_fijo'] = data.get('portabilidadFijo').value;
                }
            }
        }
        return this;
    }

    updateFijo(data: FormGroup) {
        if (data && data.controls) {
            if (data.contains('type_operation') && this.items && this.items.length) {
                this.items[0]['type_operation'] = data.get('type_operation').value;
            }
        }
        return this;
    }

    parseText(text) {
        if (typeof text !== 'string') {
            return '';
        }
        let textUCfirst = '';
        for (let i = 0; i < text.length; i++) {
            if (i === 0) {
                textUCfirst += text.charAt(i).toUpperCase();
            } else {
                textUCfirst += text.charAt(i).toLowerCase();
            }
        }
        return textUCfirst;
    }

    updateAddress(data) {
        let addresstr = '';
        addresstr += this.parseText(data.get('tipoViaCobertura').value) + ' ';
        addresstr += this.parseText(data.get('nombreViaCobertura').value) + ' ';
        addresstr += this.parseText(data.get('numeroCobertura').value) + ' ';
        addresstr += this.parseText(data.get('plantaCobertura').value) + ' ';
        addresstr += this.parseText(data.get('portalCobertura').value) + ' ';
        addresstr += this.parseText(data.get('bisCobertura').value) + ' ';
        addresstr += this.parseText(data.get('bloqueCobertura').value) + ' ';
        addresstr += this.parseText(data.get('escaleraCobertura').value) + ' ';
        addresstr += this.parseText(data.get('tipoPuertaCobertura').value) + ' ';
        addresstr += this.parseText(data.get('puertaCobertura').value) + ', ';
        addresstr += this.parseText(data.get('codigoPostalCobertura').value) + ' ';
        addresstr += this.parseText(data.get('localidadCobertura').value);
        this.address = addresstr;
        // this.updateCartInfo();
    }

    getAddress() {
        if (!this.address) {
            return '';
        }
        return this.address + ', ' + this.provincia;
    }

    getItems() {
        return this.items;
    }

    getTotal() {
        return this.total;
    }

    addItem(data) {
        const datos = data.getRawValue();

        if (datos !== null) {
            // Si es el primer paso movil de una convergente o el paso 0 de una convergente se establece el stepper_index a 1
            if(datos.rate !== null && datos.rate !== undefined && datos.rate !== '') {
                if ((datos.rate.hasOwnProperty('access') && datos.stepper_index === 0 ) ||
                    (datos.rate.type.indexOf('ftth') !== -1 && datos.stepper_index === 0)) {
                    console.log('Item access');
                    data.get('stepper_index').value = 1;
                }
            }

            if (datos.stepper_index === 'null' || datos.stepper_index === null
                || (datos.stepper_index === 0 && datos.principal !== true && (datos.rate.type !== 'mobile' && datos.rate.type !== '4G'))) {
                return;
            }
        }
        let item: any = {}
        // Parche para la comprobacion de tarifa de fijo
        if (this.items && this.items.length && this.items[0]['type_operation']) {
            item = {
                title: data.get('rate').value.name,
                portability: data.get('portability_phone').value,
                concepts: [],
                stepper_index: data.get('stepper_index').value,
                type_operation: this.items[0]['type_operation'],
                portability_fijo: this.items[0]['portability_fijo']
            };
        } else {
            item = {
                title: data.get('rate').value.name,
                portability: data.get('portability_phone').value,
                concepts: [],
                stepper_index: data.get('stepper_index').value,
                type_operation: data.get('type_operation').value === 'migration' ? data.get('type_operation').value : 'registration',
                portability_fijo: ''
            };
        }
        const rate = data.get('rate').value;
        const terminal = data.get('terminal').value;
        const terminal_payment_type = data.get('terminal_payment_type').value;
        const terminal_insurance = data.contains('terminal_insurance') ? data.get('terminal_insurance').value : undefined;

        if (typeof rate === 'object') {
            item.concepts.push({
                type: 'rate',
                desc: rate.name,
                data: rate.offers && rate.offers.length && rate.offers[0].data ? rate.offers[0].data : rate.data,
                initialCost: 0,
                monthlyCost: parseFloat(rate.price),
                months: '',
                stepper_index: data.get('stepper_index').value,
                speed: rate.offers && rate.offers.length && rate.offers[0].speed ? rate.offers[0].speed : rate.speed
            });
        }

        if (terminal && typeof terminal === 'object') {
            item.concepts.push({
                type: 'terminal',
                desc: terminal.brand + ' ' + terminal.name,
                initialCost: terminal_payment_type === 'VAP' ? parseFloat(terminal.initial_payment) : parseFloat(terminal.price),
                monthlyCost: terminal_payment_type === 'VAP' ? parseFloat(terminal.payment_quota) : 0,
                months: terminal_payment_type === 'VAP' ? terminal.payment_months : 0,
                paymentType: terminal_payment_type,
                stepper_index: data.get('stepper_index').value
            });
        }

        // Parche para no borrar el terminal cuando se cambia la tarifa en una retramitación
        if (data.get('stepper_index').value === 1 && terminal == '') {
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].stepper_index === item.stepper_index) {
                    const tmpItem = this.items[i];
                    for (let x = 0; x < tmpItem.concepts.length; x++) {
                        if (tmpItem.concepts[x].type === 'terminal') {
                            item.concepts.push(this.items[i].concepts[x]);
                        }
                    }
                }
            }
        }

        if (terminal_insurance === true) {
            item.concepts.push({
                type: 'other',
                desc: 'Seguro móvil',
                initialCost: 0,
                monthlyCost: 0,
                months: ''
            });
        }

        if (rate && typeof rate === 'object' && rate.increase) {
            item.concepts.push({
                type: 'other',
                desc: 'Incremento fibra indirecta',
                initialCost: 0,
                monthlyCost: rate.increase,
                months: ''
            });
        }

        this.operation.addItemForm(data);
        this.addItemsByStep(item);
        this.total = this.calculateTotals();
    }

    getDeliveryDescription(data) {
        if (data.pdvData !== null) {
            return 'Recogida en tienda: ' + data.pdvData.info.name;
        }

        if (data.courierData !== null) {
            return 'Envío por mensajería';
        }

        if (data.mailData !== null) {
            return 'Entrega Correos: ' + data.mailData.address.completeAddress;
        }

        return 'Gastos envío';
    }

    addItemsByStep(item) {
        let found = false;
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].stepper_index === item.stepper_index) {
                found = true;
                this.items[i] = item;
                break;
            }
        }
        if (!found) {
            console.log('PUSH ITEM', item);
            this.items.push(item);
        }
    }

    removeItemsByStep(index) {
        this.items.splice(index, 1);
        this.operation.removeItemForm(index);
        this.total = this.calculateTotals();
    }

    getMonthlyTotal() {
        let monthlyTotal = 0;
        for (const item of this.items) {
            for (const concept of item.concepts) {
                monthlyTotal += concept.monthlyCost;
            }
        }
        return monthlyTotal;
    }

    getMonthlyDiscount() {
        let prices = [];

        // Almacenar los precios
        this.items.forEach((item, indexItem) => {
            item.concepts.forEach((concept, indexConcept) => {
                if (concept.type === 'rate') {
                    // Si es una tarifa convergente le descontamos 21 para que al calcular el descuento
                    prices.push(indexConcept === 0 && concept.stepper_index === 1 ? concept.monthlyCost - 21 : concept.monthlyCost);
                }
            });
        });

        // Ordenar de mayor a menos
        prices = prices.sort((a, b) => {
            return b - a;
        });

        // Eliminar el valor mayor
        prices.shift();

        // Retorna precio con el 50% de descuento
        return prices.reduce((a, b) => a + b, 0) * 0.5;
    }

    getMonthlyTotalWithDiscount() {
        return this.getMonthlyTotal() - this.getMonthlyDiscount();
    }

    getInitialTotal() {
        let initialTotal = 0;

        for (const item of this.items) {
            for (const concept of item.concepts) {
                initialTotal += concept.initialCost;
            }
        }

        // En caso de enviar por logística, sumar el precio de envío
        if (this.terminalDelivery != null) {
            let numLogis = this.getLogisticaItems();
            initialTotal += this.terminalDelivery.deliveryPrice * (numLogis !== 0 ? numLogis : 1);
        }

        return initialTotal;
    }

    getLogisticaItems(): number {
        let numLogistica = 0;
        if (this.operation.getItemForms() && this.operation.getItemForms().length) {
            for (const item of this.operation.getItemForms()) {
                if (item.get('type_operation').value && item.get('type_operation').value.includes('logistica')) {
                    numLogistica ++;
                }
            }
        }
        return numLogistica;
    }

    // total: primera cuota + prepagos
    calculateTotals() {
        this.total = this.getMonthlyTotal() + this.getInitialTotal();
        return this.total;
    }

    hasItems() {
        return this.items.length > 0;
    }

    conceptsMonthlySubtotal(concepts) {
        let subtotal = 0;
        for (const concept of concepts) {
            subtotal += concept.monthlyCost;
        }
        return subtotal;
    }

    getConceptsWithInitialCost() {
        const concepts = [];
        for (const item of this.items) {
            for (const concept of item.concepts) {
                if (concept.initialCost > 0) {
                    concepts.push(concept);
                }
            }
        }
        return concepts;
    }

    getWithoutIVA(sum) {
        return sum / 1.21;
    }

    getOperation() {
        return this.operation;
    }

    setPdv(pdv) {
        this.pdv = pdv;
        this.operation.setPdv(pdv);
    }

    setTerminalDelivery(data: TerminalDeliveryModel) {
        this.terminalDelivery = data;
        this.calculateTotals();
    }

    getTerminalDelivery(): TerminalDeliveryModel {
        return this.terminalDelivery;
    }
}
